import { Component } from 'react';
import { ReactComponent as Clear } from 'assets/images/svg/reload.svg';
// import { ReactComponent as Clear } from 'assets/images/svg/clear.svg';

export default class RefreshIcon extends Component {

  refresh = () => {
    this.props?.dispatchFunction();
  }

  render() {
    return (
      <>
        { <span className="clear-search-icon"><Clear onClick={ this.refresh } /></span> }
      </>
    );
  }
}
